import { useState, useEffect } from "react";
import { supabase } from "./supabase";
import { guardarNotificacion } from "./NotificadorALQOS";
import BotonMapaProceso from "./BotonMapaProceso";

export default function Comunicados({ onVolver, oscuro, usuario, embebido }) {
  const [lista, setLista] = useState([]);
  const [empleados, setEmpleados] = useState([]);
  const [form, setForm] = useState({ titulo:"", mensaje:"", destino:"todos" });
  const [archivo, setArchivo] = useState(null);
  const [subiendo, setSubiendo] = useState(false);
  const [loading, setLoading] = useState(true);
  const esAdmin = usuario?.rol === "Administrador" || usuario?.rol === "RecursosHumanos";

  const C = { bg:oscuro?"#0a1129":"#F0EEFF", card:oscuro?"#0f1c3f":"#fff", navy:"#09184D", purple:"#7B5BF2", green:"#22c55e", sub:"#808085", border:oscuro?"#1e3a8a":"#dde3f0", text:oscuro?"#EDF2FA":"#2F3E2E" };
  const inp = { width:"100%", padding:"10px 14px", borderRadius:"10px", border:`1.5px solid ${C.border}`, fontSize:"13px", boxSizing:"border-box", marginTop:"6px", background:oscuro?"#0a1129":"white", color:C.text, outline:"none" };
  const lbl = { fontSize:"11px", color:C.sub, fontWeight:"700", display:"block", marginTop:"14px", textTransform:"uppercase" };
  const card = { background:C.card, borderRadius:"14px", padding:"1.2rem", border:`1.5px solid ${C.border}`, marginBottom:"12px" };

  useEffect(() => { cargar(); }, []);

  const cargar = async () => {
    setLoading(true);
    try {
      const { data } = await supabase.from("comunicados").select("data").order("id", { ascending:false });
      setLista(data ? data.map(r => r.data) : []);
      const { data: emp } = await supabase.from("empleados").select("data");
      setEmpleados(emp ? emp.map(r => r.data) : []);
    } catch(e) { console.warn(e); }
    setLoading(false);
  };

  const publicar = async () => {
    if (!form.titulo.trim() || !form.mensaje.trim()) { alert("Completá título y mensaje."); return; }
    setSubiendo(true);
    let pdf_path = null;
    try {
      if (archivo) {
        const path = `comunicados/${Date.now()}_${archivo.name}`;
        const { error } = await supabase.storage.from("recibos-sueldo").upload(path, archivo, { contentType:"application/pdf", upsert:true });
        if (!error) pdf_path = path;
      }
      const com = { id:Date.now(), titulo:form.titulo.trim(), mensaje:form.mensaje.trim(), destino:form.destino, pdf_path, publicado_por:usuario?.nombre, publicado_at:new Date().toISOString(), acuses:[] };
      const tenantId = Number(localStorage.getItem("alqos_tenant_id")) || null;
      await supabase.from("comunicados").upsert([{ id:com.id, data:com, tenant_id:tenantId }]);
      const dest = form.destino==="todos" ? empleados : empleados.filter(e => e.area===form.destino);
      dest.forEach(e => guardarNotificacion({ modulo:"Empleado", destinatario_id:e.usuario_id||e.id, tipo:"comunicado", titulo:"Nuevo comunicado", mensaje:form.titulo.trim() }));
      setForm({ titulo:"", mensaje:"", destino:"todos" }); setArchivo(null);
      await cargar();
      alert("Comunicado publicado.");
    } catch(e) { console.warn(e); alert("Error al publicar."); }
    setSubiendo(false);
  };

  const areas = [...new Set(empleados.map(e => e.area).filter(Boolean))];

  return (
    <div style={{ minHeight: embebido?"auto":"100vh", background: embebido?"transparent":C.bg, fontFamily:"sans-serif" }}>
      {!embebido && <div style={{ background:C.navy, padding:"1rem 1.5rem", display:"flex", alignItems:"center", gap:"12px", position:"sticky", top:0, zIndex:100 }}>
        <button onClick={onVolver} style={{ background:"rgba(255,255,255,0.1)", border:"none", color:"white", padding:"6px 14px", borderRadius:"10px", cursor:"pointer", fontSize:"13px" }}>← Volver</button>
        <span style={{ color:"white", fontWeight:"700", fontSize:"16px" }}>📢 Comunicados Internos</span>
        {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="comunicados" oscuro={oscuro} />}
      </div>}
      <div style={{ padding:"1.5rem", maxWidth:"700px", margin:"0 auto" }}>
        {esAdmin && (
          <div style={card}>
            <h3 style={{ fontSize:"13px", fontWeight:"700", color:C.purple, marginBottom:"4px" }}>Publicar comunicado</h3>
            <span style={lbl}>Título</span>
            <input value={form.titulo} onChange={e=>setForm(f=>({...f,titulo:e.target.value}))} style={inp}/>
            <span style={lbl}>Mensaje</span>
            <textarea value={form.mensaje} onChange={e=>setForm(f=>({...f,mensaje:e.target.value}))} rows={4} style={{...inp, resize:"vertical"}}/>
            <span style={lbl}>Destinatarios</span>
            <select value={form.destino} onChange={e=>setForm(f=>({...f,destino:e.target.value}))} style={inp}>
              <option value="todos">Todos</option>
              {areas.map(a => <option key={a} value={a}>{a}</option>)}
            </select>
            <span style={lbl}>PDF adjunto (opcional)</span>
            <input type="file" accept="application/pdf" onChange={e=>setArchivo(e.target.files[0])} style={{...inp, padding:"6px"}}/>
            <button onClick={publicar} disabled={subiendo} style={{ width:"100%", marginTop:"16px", padding:"11px", background:subiendo?C.sub:C.purple, color:"white", border:"none", borderRadius:"10px", cursor:"pointer", fontSize:"14px", fontWeight:"700" }}>
              {subiendo ? "⏳ Publicando..." : "📢 Publicar"}
            </button>
          </div>
        )}
        <h3 style={{ fontSize:"13px", fontWeight:"700", color:C.sub, margin:"20px 0 12px", textTransform:"uppercase" }}>Publicados</h3>
        {loading && <p style={{ color:C.sub, textAlign:"center" }}>⏳ Cargando...</p>}
        {!loading && lista.length===0 && <p style={{ color:C.sub, textAlign:"center", padding:"2rem" }}>Sin comunicados</p>}
        {lista.map(c => (
          <div key={c.id} style={card}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"flex-start" }}>
              <p style={{ fontSize:"14px", fontWeight:"700", color:C.navy, margin:"0 0 6px" }}>{c.titulo}</p>
              {c.pdf_path && <span style={{ fontSize:"10px", background:"#eff6ff", color:"#2A7FFF", padding:"2px 8px", borderRadius:"6px", fontWeight:"600" }}>📎 PDF</span>}
            </div>
            <p style={{ fontSize:"13px", color:C.text, margin:"0 0 8px", whiteSpace:"pre-wrap" }}>{c.mensaje}</p>
            <p style={{ fontSize:"11px", color:C.sub, margin:0 }}>
              {c.publicado_por} · {new Date(c.publicado_at).toLocaleDateString("es-AR")} · {c.destino==="todos"?"Todos":c.destino} · ✓ {c.acuses?.length||0} enterados
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
